// components/DocUploadModal.jsx
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import api from "../utils/api";
import { toast } from "react-toastify";

export default function DocUploadModal({ show, onHide, transID, onUpload }) {
  const [file, setFile] = useState(null);

  const handleUpload = async () => {
    if (!file) return toast.error("Select a docunebt file first");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("transID", transID);

    try {
      await api.post("/transactions/uploadDOC", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Document uploaded successfully");
      setFile(null);
      onUpload();
      onHide();
    } catch (err) {
      toast.error(err.response?.data?.message || "Upload failed");
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="xl"
      contentClassName="d-flex flex-column vh-100"
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-truncate">Upload Document</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mt-3">
          <input
            type="file"
            onChange={(e) => {
              setFile(e.target.files[0]);
            }}
          />
          <button className="btn btn-primary mx-2" onClick={handleUpload}>
            Upload Document
          </button>
        </div>
      </Modal.Body>

      <Modal.Footer className="justify-content-between">
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
